import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl116ValidationSchema = () => {
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");

  return yup.object().shape({
    domesticBranchGemiNumber: yup
      .object()
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocDoyBranch: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coDateDelete: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900"))
      .typeError(t("Η ημερομηνία πρέπει να είναι σε σωστή μορφή")),
    d50_id: yup.object().nullable(),
    docPraktFileDate: yup
      .date()
      .nullable()
      .min(minDate, t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"))
      .typeError(t("Η ημερομηνία πρέπει να είναι σε σωστή μορφή")),
    fudocPrakt: yup.string().nullable(),
  });
};
